import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 2.8a6.667 6.667 0 0 0-5.773 10 .669.669 0 1 0 1.16-.667 5.3 5.3 0 0 1-.72-2.666 5.333 5.333 0 1 1 9.953 2.666.665.665 0 1 0 1.153.667A6.666 6.666 0 0 0 8 2.8m1.893 3.84L8.86 7.667a1.94 1.94 0 0 0-.86-.2 2 2 0 1 0 2 2c0-.296-.069-.588-.2-.854l1.033-1.026a.668.668 0 1 0-.94-.947M8 10.133A.667.667 0 1 1 8 8.8a.667.667 0 0 1 0 1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })